import Common from "../../../../../Common";
import Item from "./callrouting/Item";

interface Body {
	pbx_did_id: id
	did_type: [
		'did',
		'internal',
		'fixed',
		'cell',
		'default'
	]
	timeout: id
	dst_busy_pbx_destination_id: id
	dst_noanswer_pbx_destination_id: id
	dst_unreachable_pbx_destination_id: id
	dst_busy_pbx_message_id: id
	dst_noanswer_pbx_message_id: id
	dst_unreachable_pbx_message_id: id
	dst_busy_voicemail: id
	dst_noanswer_voicemail: id
	dst_unreachable_voicemail: id

}

const CallRouting = class extends Common {
	item: InstanceType<typeof Item>

	constructor(headers: ApiHeaders) {
		super(headers)

		this.item = new Item(headers);
	}

	browse = (
		companyId: id,
		profileTemplateId: id,
		profileTemplateProfileId: id
	) =>
		this.get(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${profileTemplateProfileId}/callrouting`)

	create = (
		companyId: id,
		profileTemplateId: id,
		profileTemplateProfileId: id,
		body: Body
	) =>
		this.post(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${profileTemplateProfileId}/callrouting`, body)

	update = (
		companyId: id,
		profileTemplateId: id,
		profileTemplateProfileId: id,
		callroutingId: id,
		body: Body
	) =>
		this.patch(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${profileTemplateProfileId}/callrouting/${callroutingId}`, body)

	delete = (
		companyId: id,
		profileTemplateId: id,
		profileTemplateProfileId: id,
		callroutingId: id
	) =>
		this.doDelete(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${profileTemplateProfileId}/callrouting/${callroutingId}`)
}

export default CallRouting
